<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>

    <!-- 表单查询 -->
    <div class="bg-white pdt-10 pdb-10">
      <el-form ref="form" :model="form" label-width="150px" :inline="true">
        <!-- <el-form-item label="客户编号">
          <el-input
            v-model="form.customerNum"
            placeholder="请输入客户编号"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="客户电话">
          <el-input
            v-model="form.phone"
            placeholder="请输入客户电话"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否绑定家用净水机">
          <el-select clearable v-model="form.bindstatus" placeholder="请选择">
            <el-option label="未绑定" value="0"></el-option>
            <el-option label="已绑定" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="
              getList();
              getStat();
            "
            >查询</el-button
          >
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 統計 -->

    <div class="flex aic color052173 mgt-30 mgb-30">
      <div class="flex aic mgr-50">
        <span>客户总数：</span>
        <span>{{ total ? total : 0 }}</span>
      </div>
      <!-- <div class="flex aic mgr-50">
        <span>电子卡用户数：</span>
        <span>{{ statForm.eleCardNum ? statForm.eleCardNum : 0 }}</span>
      </div> -->
      <!-- <div class="flex aic mgr-50">
        <span>实物卡用户数：</span>
        <span>{{ statForm.entityNum ? statForm.entityNum : 0 }}</span>
      </div> -->
      <!-- <div class="flex aic">
        <span>双卡用户数：</span>
        <span>{{
          statForm.eleAndEntityNum ? statForm.eleAndEntityNum : 0
        }}</span>
      </div> -->
    </div>

    <btns class="mgb-20" @exec="exec"></btns>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <!-- <el-table-column prop="customerNum" label="客户编号"> </el-table-column> -->
      <el-table-column prop="customerName" label="客户昵称">
        <template slot-scope="scope">
          <span
            v-text="scope.row.customerName ? scope.row.customerName : '- -'"
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="customerPhone" label="客户电话">
        <template slot-scope="scope">
          <span v-text="scope.row.customerPhone"></span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="客户类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.userType == 1
                ? '电子水卡用户'
                : scope.row.userType == 2
                ? '实物水卡用户'
                : scope.row.userType == 3
                ? '双卡用户'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="customerPhone" label="是否绑定家用净水机">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.bindstatus === 0
                ? '未绑定'
                : scope.row.bindstatus === 1
                ? '已绑定'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column> -->

      <el-table-column prop="addTime" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="detailBtn(scope.row)" type="text" size="small"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>

    <!-- 登录密码确认弹框 -->
    <el-dialog
      :title="'密码确认'"
      :visible.sync="pwdSureVisible"
      width="20%"
      top="50vh"
      center
      :close-on-click-modal="false"
    >
      <el-form ref="pwdForm" :model="pwdForm" label-width="80px" inline>
        <el-form-item
          label="登录密码"
          prop="password"
          :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]"
        >
          <el-input
            show-password
            v-model="pwdForm.password"
            placeholder="请输入登录密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pwdSureVisible = false">取 消</el-button>
        <el-button type="primary" @click="pwdSure('pwdForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
import store from "../../store";

export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      form: {}, //查询表单数据
      statForm: {
        total: 0,
        entityNum: 0,
        towNum: 0,
        waterNum: 0,
      },
      pwdForm: {
        password: "",
      },
      pwdSureVisible: false,
      tableData: [], //表格数据
      multipleSelection: [],
      roleId: null,
      type: null,

      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数

      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
    };
  },
  created() {
    this.getList();
    this.getStat();
    this.getROLE();
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  methods: {
    lookIDBtn() {
      this.type = "lookPhone";
      this.pwdSureVisible = true;
      this.pwdForm = {
        password: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.roleId = token.roleId;
      }
    },
    // 导出按钮
    export() {
      if (this.multipleSelection.length < 1) {
        handleAlert("请选择数据", "warning");
        return;
      }
      this.type = "export";

      this.pwdSureVisible = true;
      this.pwdForm = {
        password: "",
      };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.pwdForm.clearValidate();
      });
    },
    // 密码确认
    pwdSure(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          this.$api.shebei
            .pwdNotarize({ password: this.pwdForm.password })
            .then((res) => {
              if (res.data === "密码错误!") {
                handleAlert("密码错误，请重新输入", "error");
                this.pwdForm = {};
              } else {
                if (this.type === "export") {
                  this.pwdSureVisible = false;
                  let ids = [];
                  this.multipleSelection.forEach((v) => {
                    ids.push(v.id);
                  });
                  this.$api.client.exportClient(ids).then((res) => {
                    const link = document.createElement("a");
                    link.style.display = "none";
                    link.href = URL.createObjectURL(res);
                    link.setAttribute("download", "客户信息.xls");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  });
                } else {
                  this.getPhoneList();
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    // 表格多选发生改变时
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getStat() {
      this.$api.client
        .newStat({
          customerNum: this.form.customerNum,
          customerPhone: this.form.phone,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          bindstatus: Number(this.form.bindstatus),
        })
        .then((res) => {
          if (res.code === 200) {
            console.log(res, "客户统计");
            this.statForm = res.data;
          }
        });
    },
    // 客户列表
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.client
        .clientListNew({
          pageNum: this.page,
          pageSize: this.pageSize,
          customerNum: this.form.customerNum,
          customerPhone: this.form.phone,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          // bindstatus: Number(this.form.bindstatus),
        })
        .then((res) => {
          if (res.code === 200) {
            // const phoneReg = /^(\d{3})\d{4}(\d{4})$/;
            this.tableData = res.data.list;
            // this.tableData.forEach((v) => {
            //   v.customerPhone = v.customerPhone.replace(phoneReg, "$1****$2");
            // });
            this.total = res.data.total;
            const waterNum = [];
            const entityNum = [];
            const towNum = [];
            const waterTotal = [];

            res.data.list.forEach((v) => {
              if (v.userType === 1) {
                waterNum.push(v);
              } else if (v.userType == 2) {
                entityNum.push(v);
              } else if (v.userType == 3) {
                towNum.push(v);
              }
            });
            // this.statForm.waterNum = waterNum.length;
            // this.statForm.entityNum = entityNum.length;
            // this.statForm.towNum = towNum.length;
            // this.statForm.total =
            //   Number(this.statForm.waterNum) +
            //   Number(this.statForm.entityNum) +
            //   Number(this.statForm.towNum);
          }
        });
    },
    getPhoneList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.client
        .clientList({
          pageNum: this.page,
          pageSize: this.pageSize,
          customerNum: this.form.customerNum,
          customerPhone: this.form.phone,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          dataMask: true,
        })
        .then((res) => {
          if (res.code === 200) {
            // const phoneReg = /^(\d{3})\d{4}(\d{4})$/;

            this.tableData = res.data.list;
            // this.tableData.forEach((v) => {
            //   v.customerPhone = v.customerPhone.replace(phoneReg, "$1****$2");
            // });
            this.total = res.data.total;
            this.pwdSureVisible = false;
          }
        });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    // 重置
    reset() {
      this.form = { startTime: "", endTime: "" };
      this.getList();
      this.getStat();
    },

    // 点击详情按钮进入详情页面
    detailBtn(row) {
      this.$router.push({
        path: "/client/clientList/clientDetail",
        query: {
          info: row,
        },
      });
    },

    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped>
// table表格标题
/deep/ .el-table__header .cell {
  color: var(--text-main) !important;
  font-weight: 600 !important;
}
</style>
